<script setup>
import { useRoute } from 'vue-router'

const route = useRoute()
</script>

<template>
  <nav class="navbar navbar-expand-sm navbar-light bg-light">
    <div class="container-fluid">
      <a
        href="https://mantester.com/"
        class="navbar-brand"
      >ManTester</a>
      <button
        type="button"
        class="navbar-toggler"
        data-bs-toggle="collapse"
        data-bs-target="#navbar-content"
        aria-controls="navbar-content"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon" />
      </button>
      <div
        v-if="route.name !== 'SharedResults'"
        id="navbar-content"
        class="collapse navbar-collapse"
      >
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <router-link
              :to="{ name: 'Home' }"
              class="nav-link"
            >
              Home
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              :to="{ name: 'Connect' }"
              class="nav-link"
            >
              Connect
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              :to="{ name: 'Setup' }"
              class="nav-link"
            >
              Setup
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              :to="{ name: 'Execute' }"
              class="nav-link"
            >
              Execute
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              :to="{ name: 'Results' }"
              class="nav-link"
            >
              Results
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              :to="{ name: 'Share' }"
              class="nav-link"
            >
              Share
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
